/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import { Button } from '@salesforce/design-system-react';
import PropTypes from 'prop-types';
import React from 'react';
import { ProvisionedCard } from '../../homepage-card';
import EinsteinImage from './einstein-analytics@2x.png';
import EinsteinIcon from './einstein';

function EinsteinLearningCenterCard({ className, heading, localizations, onDeepLink }) {
  const einsteinIcon = (
    <span
      className="slds-icon_container slds-icon-standard-account"
      title={localizations['homepage.cards.learning_center.icon_assistive']}
    >
      <EinsteinIcon className="slds-icon slds-icon--small" />
      <span className="slds-assistive-text">{localizations['homepage.cards.learning_center.icon_assistive']}</span>
    </span>
  );

  return (
    <ProvisionedCard
      className={className}
      heading={heading}
      icon={einsteinIcon}
      forceShowFooter
      footer={
        <Button
          label={localizations['homepage.cards.learning_center.button_label']}
          onClick={() => onDeepLink({ appName: 'Einstein Overview' })}
          variant="brand"
          className="slds-size_1-of-1"
        />
      }
    >
      <div className="einstein-learning-center_flag">{localizations['homepage.cards.learning_center.flag']}</div>
      <div className="einstein-learning-center_body">
        <div className="slds-text-color--weak slds-p-around--medium">
          {localizations['homepage.cards.learning_center.body']}
        </div>
        <div className="einstein-learning-center_img-container">
          <img
            className="einstein-learning-center_img"
            src={EinsteinImage}
            alt={localizations['homepage.cards.learning_center.image_alt']}
          />
        </div>
      </div>
    </ProvisionedCard>
  );
}

EinsteinLearningCenterCard.displayName = 'Einstein Learning Center';

EinsteinLearningCenterCard.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string,
  localizations: PropTypes.object,
  onDeepLink: PropTypes.func,
};

export default EinsteinLearningCenterCard;
